import * as React from "react";
import { observer } from "mobx-react";
import { useContext, useState } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Form, Button, Spin } from "antd";
import { RouteComponentProps } from "react-router-dom";
import { WeddingDateFormItem } from "../molecules/WeddingDateFormItem";
import * as firebase from "firebase/app";
import "firebase/auth";
import { MainNameFormItem } from "../molecules/MainNameFormItem";
import { SubNameFormItem } from "../molecules/SubNameFormItem";
import { Footer } from "../organisms/Footer";
import { ArrowLink } from "../atoms/ArrowLink";
import { css } from "@emotion/core";
import { large } from "../../style/button";
import { title } from "../../style/header";
import { arrowLinkContainer } from "../../style/layout";

export const Signup = observer(({ history }: RouteComponentProps) => {
  const store = useContext(ContactViewStoreContext);

  const [loading, setLoading] = useState(false);

  return (
    <div>
      <h3 css={title}>お申込み(未登録)</h3>

      <Form
        labelCol={{ xs: { span: 24 }, sm: { span: 8 } }}
        wrapperCol={{ xs: { span: 24 }, sm: { span: 12 } }}
      >
        <WeddingDateFormItem />
        <MainNameFormItem />
        <SubNameFormItem />
      </Form>

      <div
        css={css`
          margin: 0 40px 40px;
        `}
      >
        <button
          css={large}
          disabled={loading}
          onClick={() => {
            if (!store.hasBasicContactInfo) {
              alert("すべての項目を埋めてください");
              return;
            }

            setLoading(true);

            // リロードを避けるため、匿名ユーザーを作る前にstoreをinitialized扱いにする。
            store.initialized = true;

            // 匿名ユーザーを作成し、次の画面へ遷移
            firebase
              .auth()
              .signInAnonymously()
              .then(
                () => {
                  history.push("/application/contact");
                },
                _ => {
                  alert("エラーが発生しました。");
                  setLoading(false);
                }
              );
          }}
        >
          OK
          {loading && <Spin size="small" />}
        </button>
      </div>

      <div css={arrowLinkContainer}>
        <ArrowLink to="/signin" direction="left">
          <div>
            アカウントをお持ちの方はこちら
            <br />
            <small>資料請求、見積り済の方</small>
          </div>
        </ArrowLink>
      </div>

      <div css={arrowLinkContainer}>
        <ArrowLink to="/inquiry/contact1" direction="left">
          <div>まず資料請求をご希望の方はこちら</div>
        </ArrowLink>
      </div>

      <Footer />
    </div>
  );
});
